const readMore = document.getElementById('collection-read-more');
const readLess = document.getElementById('collection-read-less');

readMore.addEventListener('click', (e) => {
    e.preventDefault();
    const description = document.getElementById('description-wrapper');
    description.classList.remove('truncate');
    readMore.style.display = 'none';
    readLess.style.display = 'block';
});

readLess.addEventListener('click', (e) => {
    e.preventDefault();
    const description = document.getElementById('description-wrapper');
    description.classList.add('truncate');
    readMore.style.display = 'block';
    readLess.style.display = 'none';
});